import React from 'react';
import { VStack, Text, HStack, Input, Image } from '@chakra-ui/react';
import logo from "../../assets/tea-logoVersion.svg";

function ParentArea({ birthYear }) {
  // Note that birthYear is a string, and we use it directly.

  return (
    <VStack spacing={4} align="center" width="100%"> {/* Centrado horizontal */}
      <Image
        src={logo}
        boxSize="50px"
        alt="Logo"
        width="220.68px"
        height="101px"
        flexShrink={0}
      />

      <Text
        fontSize="32px"
        color="#303030"
        textAlign="center"
        fontFamily="Poppins"
        fontWeight="600"
        fontStyle="normal"
        lineHeight="18px"
        letterSpacing="-0.01px"
        marginTop="20px"
        marginBottom="20px"
      >
        Parent Zone
      </Text>

      <Text
        color="#AFAFAF"
        fontFamily="Manrope"
        fontSize="18px"
        fontStyle="normal"
        fontWeight="500"
        lineHeight="normal"
        letterSpacing="0.9px"
        marginTop="5px"
        marginBottom="20px"
      >
        Enter your year of birth:
      </Text>
      
      <HStack>
  {Array(4).fill('').map((_, index) => (
    <Input
      key={index}
      value={birthYear[index] || ''} // Access string characters directly.
      isReadOnly
      placeholder="-"
      size="lg"
      width="84px"
      textAlign="center"
      height="80px" // Establecer altura a 80px
      
    />
  ))}
</HStack>

    </VStack>
  );
}

export default ParentArea;
